export default "__VITE_ASSET__DrRnJCWT__"